module.exports = __webpack_public_path__ + "static/Colas-5b0dfbb242fc845ca2275d197aff5725.jpg";